import { Instance } from 'mobx-state-tree';
import { RouteTimelineEventSummaryDtoModelBase } from './RouteTimelineEventSummaryDtoModel.base';
import { RouteTimelineEventException } from './RouteTimelineEventExceptionEnum';

/* The TypeScript type of an instance of RouteTimelineEventSummaryDtoModel */
export interface RouteTimelineEventSummaryDtoModelType extends Instance<typeof RouteTimelineEventSummaryDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineEventSummaryDtoModel */
export { selectFromRouteTimelineEventSummaryDto, routeTimelineEventSummaryDtoModelPrimitives, RouteTimelineEventSummaryDtoModelSelector } from './RouteTimelineEventSummaryDtoModel.base';

/**
 * RouteTimelineEventSummaryDtoModel
 */
export const RouteTimelineEventSummaryDtoModel = RouteTimelineEventSummaryDtoModelBase
  .views(self => ({
    get hasDeliveryIssue() {
      return self.exception === RouteTimelineEventException.DELIVERY_ISSUE;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
